import { useEffect, useState } from 'react';
import { supabase } from '../utils/supabaseClient';
import { trackEventRaw } from '../utils/track';
import { takeReturn, returnUrl } from '../utils/returnTo';
import './EmailGate.css';

export default function AuthCallback() {
  const [status, setStatus] = useState('loading'); // loading | error

  useEffect(() => {
    // Supabase appends the session tokens to the URL hash or query string.
    // getSession() picks them up automatically from the current URL.
    supabase.auth.getSession()
      .then(({ data, error }) => {
        if (error || !data.session) {
          setStatus('error');
          return;
        }
        // Session established — store email hint and go to the terminal
        const user = data.session.user;
        const email = user?.email;
        if (email) localStorage.setItem('terminal_email', email);

        /* Hírlevél-hozzájárulás: a belépő űrlap a user_metadata-ba írja
           (ugyanaz a kulcs, mint a landingen), innen kerül a profilba. Csak friss
           regisztrációnál és csak igen-re: a metadata a regisztrációkori állapot,
           egy későbbi belépés így nem írhatja felül, ha azóta leiratkozott. */
        const fresh = Date.now() - Date.parse(user?.created_at || 0) < 24 * 3600 * 1000;
        const sync = user?.user_metadata?.newsletter_consent === true && fresh
          ? supabase.from('profiles').update({ newsletter_consent: true }).eq('id', user.id)
            .then(() => undefined, () => undefined)
          : Promise.resolve();
        /* A gyakorló bemutatójából indult regisztráció: vissza az egyetem
           gyakorlójára, a session átadásával (returnTo.js, engedélylistás cél). */
        const back = takeReturn();
        sync.then(() => window.location.replace(back ? returnUrl(back, data.session) : '/'));
      })
      /* A getSession() nem csak {data, error}-t adhat: DOBHAT is
         (NavigatorLockAcquireTimeout). .catch() nélkül a status örökre
         'loading' maradt, és a "Belépés folyamatban…" képernyő beragadt —
         méghozzá a belépési út kellős közepén. */
      .catch((e) => {
        console.warn('[auth-callback] getSession sikertelen:', e?.message || e);
        trackEventRaw('auth_init_failed', {
          stage: 'terminal_auth_callback',
          error: String(e?.name || 'unknown'),
          message: String(e?.message || '').slice(0, 200),
        });
        setStatus('error');
      });
  }, []);

  if (status === 'loading') {
    return (
      <div className="eg-overlay">
        <div className="eg-modal eg-modal--return">
          <div className="eg-top-bar" />
          <div className="eg-confirm-inner">
            <div className="eg-title">⚡ KRIPTO TERMINÁL</div>
            <div className="cp-icon">
              <span className="eg-spinner" style={{ fontSize: 36 }}>◈</span>
            </div>
            <div className="cp-heading">Belépés folyamatban…</div>
            <div className="cp-body">Egy pillanat, hitelesítjük a belépő linket.</div>
          </div>
        </div>
      </div>
    );
  }

  // error state — link expired or already used
  return (
    <div className="eg-overlay">
      <div className="eg-modal">
        <div className="eg-top-bar" />
        <div className="eg-confirm-inner">
          <div className="eg-title">⚡ KRIPTO TERMINÁL</div>
          <div className="cp-icon">⏰</div>
          <div className="cp-heading">A link lejárt vagy érvénytelen</div>
          <div className="cp-body">
            A belépő link 1 óráig érvényes, egyszer használható.<br />
            Kérj új linket a terminál főoldalán!
          </div>
          <button
            className="eg-submit"
            onClick={() => { window.location.href = '/'; }}
          >
            ← Vissza a belépési oldalra
          </button>
        </div>
      </div>
    </div>
  );
}
